export default __webpack_public_path__ + "static/media/Visual_joil_12.b7206cd6.jpg";